import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from '@mui/material';

export default function AdminCardEditDialog({ open, card, onClose, onSave }) {
  const [form, setForm] = useState(card || {});

  React.useEffect(() => {
    setForm(card || {});
  }, [card]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    onSave(form);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Card</DialogTitle>
      <DialogContent>
        <TextField margin="dense" label="Card Number" name="card_number" value={form.card_number || ''} onChange={handleChange} fullWidth disabled />
        <TextField margin="dense" label="Type" name="type" value={form.type || ''} onChange={handleChange} select fullWidth>
          <MenuItem value="debit">Debit</MenuItem>
          <MenuItem value="credit">Credit</MenuItem>
        </TextField>
        <TextField margin="dense" label="Status" name="status" value={form.status || ''} onChange={handleChange} select fullWidth>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="blocked">Blocked</MenuItem>
        </TextField>
        <TextField margin="dense" label="Expiry" name="expiry" value={form.expiry || ''} onChange={handleChange} fullWidth />
        <TextField margin="dense" label="CVC" name="cvc" value={form.cvc || ''} onChange={handleChange} fullWidth />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
